import { render, staticRenderFns } from "./FinancePacksRoi.vue?vue&type=template&id=83096d78&"
import script from "./FinancePacksRoi.vue?vue&type=script&lang=js&"
export * from "./FinancePacksRoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports